import styled from "styled-components";

export const PageWrapper = styled.div`
  display: grid;
  grid-template-columns: 356px 1fr;
  gap: 32px;
  margin-left: -40px;

  @media (max-width: 1030px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, max-content);
    margin-right: -40px;
    gap: unset;
  }

  @media (max-width: 767px) {
    margin: 0 -24px;
  }
`;
